// extracted by mini-css-extract-plugin
export default {"date":"html_date__BlQWu","input":"html_input__ZA3WL"};